export const ADP_HELP_ARTICLE_URL = 'https://support.recruitee.com/articles/7870482';
export const TERMS_URL = 'https://recruitee.com/en/terms';
export const ADP_MANAGE_APPS_URL = 'https://apps.adp.com/account/apps';
